import { MaterialRequirement } from '../../../../types/api/components/material/material-requirements'
import { MaterialsColumnCell } from '../../components/cells/materials-column-cell'
import { DataSourceItem } from '../../shipments-page'
import { ShipmentColumn } from '../../types/column-types'
import { validateMaterial } from '../../helpers/validators/material-validator'

export const materialsColumn: ShipmentColumn = {
    key: 'materials',
    dataIndex: 'materialRequirements',
    title: 'Материалы',
    width: 70,
    render: (v: MaterialRequirement[], r: DataSourceItem) => (
        <MaterialsColumnCell value={v} record={r} />
    ),
    onCell: () => ({
        style: { maxWidth: 80 },
    }),
    validator: validateMaterial,
}
